<div class="pv-input" [formGroup]="form">
	@if (label) {
		<ic-label [help]="help" [required]="required">
			{{ label }}
		</ic-label>
	}

	<textarea
		formControlName="value"
		[attr.disabled]="disabled || null"
		[class]="inputClass"
		(blur)="onTouched()"
		(input)="onChange($any($event).target.value)"
	>
	</textarea>

	<div class="error-text"><ng-content select=".errors" /></div>
</div>
